// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Banner-components-BannerIcon-module__IconContainer";
export { _1 as "IconContainer" }
